import { useState, useCallback } from 'react';

/**
 * Encapsulates open/close state and handlers for the driver score tooltip.
 *
 * Use this hook when you need controlled tooltip visibility (e.g. with
 * ClickAwayListener). Handlers are memoized with useCallback so they stay
 * stable across re-renders.
 *
 * @returns Visibility state and control callbacks
 * @returns visible - Whether the component is currently visible
 * @returns handleVisible - Callback to make the component visible (e.g. on trigger click)
 * @returns handleInvisible - Callback to make the component invisible (e.g. on close button or click-away)
 */
export const useHandleVisible = () => {
	const [visible, setVisible] = useState(false);

	const handleVisible = useCallback(() => {
		setVisible(true);
	}, []);

	const handleInvisible = useCallback(() => {
		setVisible(false);
	}, []);

	return {
		visible,
		handleVisible,
		handleInvisible,
	};
};
